import type { ReactNode } from 'react';

export const symbol_add_location_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458.5-103.5Q448-107 440-115q-42-38-91-87.5T258-309q-42-57-70-119t-28-124q0-103 52-185t147-120q37-15 76.5-20t78.5-1q14 2 22.5 11.5T544-843q-1 12-10.5 19.5T511-818q-35-5-68-.5T378-800q-76 32-117 99t-41 149q0 75 65 173.5T480-159q66-60 115-114.5T676-378q28-43 45-85t18-90q0-16 10-23.5t21-7.5q11 0 20.5 8t9.5 23q-1 71-32.5 136T694-296q-45 58-92 105t-82 76q-8 8-18.5 11.5T480-100q-11 0-21.5-3.5Zm71-407Q550-531 550-560t-20.5-49.5Q509-630 480-630t-49.5 20.5Q410-589 410-560t20.5 49.5Q451-490 480-490t49.5-20.5ZM480-560Zm252-212v98q0 13 8.5 21.5T762-644q13 0 21.5-8.5T792-674v-98h98q13 0 21.5-8.5T920-802q0-13-8.5-21.5T890-832h-98v-98q0-13-8.5-21.5T762-960q-13 0-21.5 8.5T732-930v98h-98q-13 0-21.5 8.5T604-802q0 13 8.5 21.5T634-772h98Z"
		/>
	</svg>
);
